import { useTranslation } from 'react-i18next';

import type { BookingClient } from '@/types/api/queries';

import { Badge } from '@/components/ui/badge';

import { cn } from '@/lib/utils';

import { bookingPersonName } from '@/helpers';

type BookingPersonNameProps = {
  client: BookingClient;
  guestInfo: string | null;
  className?: string;
};

export const BookingPersonName = (props: BookingPersonNameProps) => {
  const { client, guestInfo, className } = props;
  const { t } = useTranslation();

  return (
    <span className={cn('inline-flex items-center gap-1.5', className)}>
      <span className="truncate">
        {bookingPersonName(client, guestInfo, t('Guest'))}
      </span>
      {client?.is_new && (
        <Badge
          variant="destructive"
          className="shrink-0 px-1 py-0 text-[10px]"
        >
          {t('New')}
        </Badge>
      )}
    </span>
  );
};
